export enum PokemonTypes {
  NORMAL = "normal",
  FIGHTING = "fighting",
  FLYING = "flying",
  POISON = "poison",
  GROUND = "ground",
  ROCK = "rock",
  BUG = "bug",
  GHOST = "ghost",
  STEEL = "steel",
  FIRE = "fire",
  WATER = "water",
  GRASS = "grass",
  ELECTRIC = "electric",
  PSYCHIC = "psychic",
  ICE = "ice",
  DRAGON = "dragon",
  DARK = "dark",
  FAIRY = "fairy"
}

export const Types = [
  PokemonTypes.NORMAL,
  PokemonTypes.FIGHTING,
  PokemonTypes.FLYING,
  PokemonTypes.POISON,
  PokemonTypes.GROUND,
  PokemonTypes.ROCK,
  PokemonTypes.BUG,
  PokemonTypes.GHOST,
  PokemonTypes.STEEL,
  PokemonTypes.FIRE,
  PokemonTypes.WATER,
  PokemonTypes.GRASS,
  PokemonTypes.ELECTRIC,
  PokemonTypes.PSYCHIC,
  PokemonTypes.ICE,
  PokemonTypes.DRAGON,
  PokemonTypes.DARK,
  PokemonTypes.FAIRY
];
